import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'
import { LearnerMirrorSection } from './parts/LearnerMirrorSection'
import { CoachingMetaSection } from './parts/CoachingMetaSection'
import { QuestionResultCard } from './parts/QuestionResultCard'
import { PartialDataFallback } from './parts/PartialDataFallback'
import { formatAnswer } from './formatAnswer'

interface Props {
  component: ComponentProgressDetailView
}

export function AssignmentCoachingDetail({ component }: Props) {
  const { t } = useTranslation('coaching')
  const assign = component.assignment
  if (!assign) return <PartialDataFallback type="assignment" />

  const responses = assign.responses ?? []

  return (
    <div className="space-y-3">
      <LearnerMirrorSection title={t('section.learnerView')}>
        <ul className="space-y-2">
          {responses.map((r, idx) => (
            <li key={`${r.quizId}-${idx}`}>
              {r.questionSnapshot ? (
                <QuestionResultCard
                  order={idx}
                  questionSnapshot={r.questionSnapshot}
                  studentAnswer={r.answer}
                  variant="mirror"
                />
              ) : (
                <p className="text-xs italic text-gray-500">{t('assignment.noSnapshot')}</p>
              )}
            </li>
          ))}
        </ul>
      </LearnerMirrorSection>
      <CoachingMetaSection title={t('section.coachingMeta')}>
        <div className="text-xs text-gray-500 space-y-0.5">
          {assign.diaryQuizSetId != null && <div>diaryQuizSetId: {assign.diaryQuizSetId}</div>}
          <div>{t('assignment.responseCount', { n: responses.length })}</div>
          {responses.map((r, i) => (
            <div key={`${r.quizId}-${i}`} className="text-gray-700">
              Q{i + 1}: {formatAnswer(r.answer)}
            </div>
          ))}
        </div>
      </CoachingMetaSection>
    </div>
  )
}
